<script lang="ts">
import { VNode, defineComponent, h } from 'vue';

import { Nullable } from '@/utils/types';
import { formatJSDate } from '@/utils/filters';

// The list API sends 0 for a missing date, which renders as N/A like null.
interface IProps {
  leaseCommencement: Nullable<string | number>;
  leaseExpiration: Nullable<string | number>;
}

export default defineComponent({
  name: 'LeaseCommencementExpirationLabel',

  props: {
    leaseCommencement: {
      type: [String, Number],
      default: null,
    },
    leaseExpiration: {
      type: [String, Number],
      default: null,
    },
  },

  render (): VNode {
    const { leaseCommencement, leaseExpiration } = this.$props as IProps;

    let displayText: string;

    if (!leaseCommencement && !leaseExpiration) {
      // Both are null -> N/A
      displayText = 'N/A';
    } else if (leaseCommencement && leaseExpiration) {
      // Both present -> {{ lease-commencement }} - {{ lease-expiration }}
      displayText = `${formatJSDate(leaseCommencement)} - ${formatJSDate(leaseExpiration)}`;
    } else if (leaseCommencement && !leaseExpiration) {
      // lease-commencement has value and lease-expiration doesn't -> {{ lease-commencement }}
      displayText = formatJSDate(leaseCommencement) as string;
    } else {
      // lease-commencement hasn't value and lease-expiration has -> N/A - {{ lease-expiration }}
      displayText = `N/A - ${formatJSDate(leaseExpiration)}`;
    }

    return h('span', displayText);
  },
});
</script>
